import { Suspense } from 'react';

import { Wrapper } from './index.styles';

import Content from './content';
import Nav from './nav';
import TransactionsMonitor from './transactions_monitor';
import UrgentMessagesMonitor from './urgent_messages_monitor';
import WebsocketHandler from './websocket_handler';
import YourCodeDialog from './your_code_dialog';

export default function IndexPage() {
  return (
    <Wrapper>
      <Nav />
      <Content />
      <YourCodeDialog />
      <WebsocketHandler />
      <Suspense fallback={null}>
        <TransactionsMonitor />
      </Suspense>
      <Suspense fallback={null}>
        <UrgentMessagesMonitor />
      </Suspense>
    </Wrapper>
  );
}
